import { useMutation } from '@tanstack/react-query';
import { bulkApproveBankOperation } from 'config/requests/bankOperations';
import { queryClient } from 'providers/queryClient';

export function useBulkApproveRequestsBankOps() {
  const mutation = useMutation({
    mutationFn: ({ ids }: { ids: number[] }) => bulkApproveBankOperation(ids),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['bank_operations/pending_statuses'] });
    },
  });

  return { bulkApproveRequestsBankOps: mutation };
}
